import React, {Component, createRef, Fragment, h} from "preact";
import {AppPage} from "../../_common/components/app-page";
import {connect} from "react-redux";
import {
    uploadDocument, uploadSignature,
} from "../../_rx/student/actions";

import { C, CF, E, FR, R } from "../../_common/layout";

import {t} from '../../_i18n';

import CanvasDraw from "react-canvas-draw";
import {EsRequirements} from "../components/es-requirements";
import {PS_SHOPID_ES} from "../../constants";
import { Form as FinalForm } from 'react-final-form'
import {TechnicalRequirements} from "../components/it-technical-requirements";
import {isSpanishStudent} from "../../utils";
import getLangByShopId, {isSpanishUser} from "../../_common/utils/getLang";
import { RadioCheckbox } from '../../_common/forms/components/components'
import AlertBox from '../../_common/components/AlertBox/AlertBox'

const TermsES = ()=><CF className="sm-card max-width-sm">
    <div className="sm-p-x2-top sm-p-x2-bottom sm-p-left sm-p-right t-justify">
        <h2>INFORMACIÓN GENERAL</h2>
        <ol className='m-x2-top'>
            <li>Tendrán acceso aquellos/as alumnos/as mayores de edad o que cumplan 18 años en el año natural en que se matriculan,
                y que cumplan con los requisitos de acceso al ciclo formativo.</li>
            <li>Con carácter excepcional pueden acceder a los ciclos formativos de grado medio y grado superior en la modalidad a
                distancia, las personas que posean el graduado en educación secundaria obligatoria y tengan como mínimo 16 años
                cumplidos en el año natural en el que se matriculan, y que acrediten encontrarse en alguna de las siguientes situaciones:
                <ul>
                    <br/>
                    <li>Trabajando.</li>
                    <li>Estar cuidando a una persona dependiente.</li>
                    <li>Concurrencia de circunstancias excepcionales que le impidan o dificulten el seguimiento de las enseñanzas
                        presenciales.</li>
                </ul>
                Las solicitudes excepcionales se resolverán por el director o la directora del centro donde el alumno se quiera matricular.
            </li>
            <li>En el caso de que se estudie un mismo ciclo formativo en dos centros diferentes a la vez, es obligatorio que el/la
                alumno/a no esté matriculado de los mismos módulos/créditos dentro del mismo curso. <br/> <br/>

                En el mismo curso académico, queda también prohibido cursar un módulo/crédito (tanto en modalidad presencial como a
                distancia) y hacer la inscripción para el mismo crédito/módulo a las pruebas de obtención de títulos de formación profesional. <br/> <br/>

                No existe la posibilidad de matricularse en un crédito/módulo ya aprobado con anterioridad en otro centro. En caso de que
                ILERNA Online identifique esta incompatibilidad prevalecerá siempre la primera nota obtenida. <br/> <br/>
            </li>
            <li>En caso de que un/a alumno/a se haya matriculado de un ciclo del cual no cumple los requisitos de acceso, se le devolverá
                el 30% del importe total de su matrícula. Para proceder a la devolución, será requisito indispensable que el alumno haya
                presentado la documentación de los requisitos de acceso hasta a un máximo de 15 días después de la fecha de inicio del
                curso.</li>
            <li>
                El/la alumno/a acepta el uso de sus datos personales para su tratamiento en un fichero automatizado. Asimismo, se le
                informa que la recogida de dichos datos tienen como finalidad la gestión y control de la matrícula del ciclo formativo y
                la elaboración de informes estadísticos.<br/><br/>

                El alumno acepta la cesión de datos de carácter personal en caso de ser necesaria la realización de un examen vía online. <br/><br/>

                En el caso de alumnos que se matriculen en productos que se imparten en colaboración con un tercero (p.e UCAM), se informa
                que sus datos personales una vez cedidos a ILERNA, podrán ser tratados por el tecero, con el único objeto de supervisar la
                superación de las materias y expedir la titulación correspondiente. Éste asume la obligación de respetar el secreto profesional
                y custodiar los datos conforme a lo dispuesto en la LOPD.
            </li>
            <li>
                Los ciclos formativos de Formación Profesional que imparte ILERNA Online son oficiales y se regulan según
                la normativa vigente que establece la administración. En consecuencia, ILERNA Online deberá quedar
                exonerada de cualquier responsabilidad cuando se produzcan cambios o modificaciones en la normativa de la
                administración que afecte al funcionamiento o características de los ciclos formativos, y el/la alumno/a así lo acepta.
            </li>
            <li>
                En el supuesto en que los exámenes deban realizarse en modalidad online, el/la alumno/a deberá tener instalada una
                videocámara y micrófono (al menos con acceso a video) en el ordenador con el que vaya a realizar el examen. <br/><br/>

                En estos casos podrá ser necesario el uso de sistemas de reconocimiento facial para verificar la identificación del alumno. Se
                informará previamente al alumno/a sobre el uso de esta tecnología si resultara necesaria su utilización para la realización de
                las pruebas de evalución. Su uso será restringido y conforme a la normativa vigente en materia de protección de datos de
                carácter personal.
            </li>
        </ol>
        <h2 className='m-x2-top'>DERECHO DE DESISTIMIENTO CONFORME AL TEXTO REFUNDIDO DE LA LEY DE DEFENSA DE CONSUMIDORES Y USUARIOS</h2> <br/>
        En virtud de lo previsto en el Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el texto refundido
        de la Ley General para la Defensa de los Consumidores y Usuarios y otras leyes complementarias, el alumno de ILERNA
        Online, como consumidor y usuario, tiene derecho a desistir del contrato celebrado a distancia y solicitar la devolución de su
        importe en las condiciones previstas en el presente apartado, al amparo de lo establecido en los artículos 104 y siguientes de
        la mencionada ley. <br/> <br/>

        <ol>
            <li>El plazo para ejercitar el derecho de desistimiento expirará una vez transcurridos 14 días naturales desde la fecha de
                celebración del contrato (fecha de matrícula), a través de una declaración inequívoca en la que señale su decisión
                de desistir del contrato dirigida a la siguiente dirección: ILERNA Online. Turó de Gardeny, Complejo Magical Media,
                Edificio 5 (25003) Lleida, o por correo electrónico: online@ilerna.es. Para ello, podrá utilizar el modelo de formulario de
                desestimiento que figura anexo a este documento. <br/><br/>

                Para cumplir el plazo de desistimiento, basta con que la comunicación relativa al ejercicio de este derecho sea enviada por el
                consumidor antes de que venza el plazo correspondiente. <br/><br/>

                Una vez finalizado dicho plazo, el alumno no podrá desistir del contrato y la baja del alumno no implicará el derecho a la
                devolución del dinero.
            </li>
            <li>
                En caso de que el alumno ejercite su derecho de desistimiento dentro del plazo anteriormente descirto, se procederá a
                la devolución de los pagos recibidos, siempre que se cumpla con los requisitos, en el plazo de 14 días naturales desde
                la fecha en la que hayamos sido informados de la decisión de desistimiento del alumno. <br/> <br/>

                Procederemos a efectuar dicho reembolso utilizando el mismo medio de pago empleado por el alumno en la transacción
                inicial a no ser que el alumno haya dispuesto expresamente lo contrario y siempre y cuando no incurra en ningún gasto como
                consecuencia del reembolso. No obstante, en caso de que el alumno haya seleccionado expresamente una modalidad de
                entrega diferente a la modalidad menos costosa de entrega ordinaria, ILERNA Online no estará obligado a reembolsar los
                costes adicionales que de ello se deriven.
            </li>
            <li>
                El derecho de desistimiento anteriormente descrito tendrá un régimen especial en los siguientes casos: <br/><br/>

                <span className='bold'>Alumnos matriculados con el curso iniciado o alumnos matriculados con anterioridad al inicio del curso, pero cuyo derecho
                de desistimiento pueda ser ejercido una vez iniciado el curso:</span> <br/><br/>

                En el supuesto de que el alumno ejercite su derecho de desistimiento dentro del plazo de 14 días naturales desde la celebración
                del contrato pero una vez iniciado el curso y, por lo tanto, tengan acceso directo al material didáctico, clases, comunicación
                con docents, etc. éste podrá solicitar la devolución del importe, dentro del plazo indicado, pero deberá abonar a ILERNA
                Online del ejercicio del derecho de desistimiento, en relación con el objeto total del contrato. <br/> <br/>

                <span className='bold'>Alumnos Premium:</span> <br/><br/>

                Los alumnos que contraten el servicio Premium, tienen acceso directo al material didáctico del Campus Virtual desde el
                momento de la contratación (matrícula) y pueden obtener los libros en formato físico de manera gratuita, por su condición de
                “Alumno Premium”. <br/><br/>

                Estos alumnos podrán ejercitar su derecho de desistimiento, dentro de los 14 días naturales desde la fecha de matriculación,
                pero deberán abonar a ILERNA Online el importe proporcional a la parte ya prestada del servicio en el momento en que haya
                informado a ILERNA Online del ejercicio del derecho de desistimiento, en relación con el objeto total el contrato. <br/><br/>

                El precio del servicio Premium no es reembolsable. <br/><br/>

                <span className='bold'>Devolución de material (libros, merchandising, etc.):</span><br/><br/>

                El alumno podrá ejercitar su derecho de desistimiento de la compra del material del ciclo, en un plazo de 14 días naturales
                desde la recepción del material por el propio alumno o un tercero distinto del transportista debidamente identificado e
                indicado por el alumno. <br/><br/>

                En caso de los materiales que formen parte de un mismo pedido, pero cuya entrega se realice por separado, el alumno podrá
                ejercitar su derecho de desistimiento, en un plazo de 14 días naturales desde la recepción del último de estos materiales por
                el propio alumno o un tercero distinto del transportista debidamente identificado e indicado por el alumno. <br/><br/>

                En caso de desistimiento por parte del alumno, éste deberá devolver directamente los materiales a ILERNA ONLINE, S.L.
                (Dirección: Turó de Gardeny, Complejo Magical Media, Edif 5, 25003, Lleida), sin ninguna demora indebida y, en cualquier
                caso, a más tardar en el plazo de 14 días naturales a partir de la fecha en que comunique su decisión de desistimiento del
                contrato. Se considerará cumplido el plazo si efectúa la devolución de los materiales antes de que haya concluido dicho plazo. <br/><br/>

                El alumno soportará los costes directos de devolución de los bienes. <br/><br/>

                ILERNA Online devolverá todos los pagos recibidos, incluidos los gastos de la entrega original de los bienes (con la excepción
                de los gastos adicionales resultantes de la elección por parte del alumno de una modalidad de entrega diferente a la
                modalidad menos costosa de entrega ordinaria que ofrezcamos) sin ninguna demora indebida y, en todo caso, a más tardar
                14 días naturales a partir de la fecha en la que se informe a ILERNA Online de su decisión de desistir del contrato. No obstante,
                ILERNA Onine podrá retener el reembolso de las cantidades hasta haber recibido los materiales, o hasta que el alumno haya
                presentado una prueba de la devolución de los materiales, según qué condición se cumpla primero. Asimismo, el alumno será
                responsable de la disminución de valor de los materiales resutante de una manipulación distinta a la necesaria para establecer
                la naturaleza, las características y el funcionamiento de los materiales. <br/><br/>

                El derecho de desistimiento del alumno se aplicará exclusivamente a los materiales que se devuelvan en las mismas
                condiciones en las que se encontraban en el momento de la recepción. En consecuencia, no procederá el reembolso de los
                materiales usados o dañados. <br/><br/>
            </li>
            <li>
                ILERNA Online se reserva del derecho de no aceptar desistimientos comunicados o enviados fuera del plazo fijo.
            </li>
            <li>
                No se realizará, en ningún caso, la devolución del importe abonado en concepto de “Reserva de plaza” debido a la
                condición del mismo.
            </li>
            <li>
                Se excluye del derecho de desistimiento a los contratos mencionados en el artículo 103 del Real Decreto Legislativo 1/2007
                de 16 de noviembre por el que se aprueba el texto refundido de la Ley General para la Defensa de los Consumidores y
                Usuarios y otras leyes complementarias.
            </li>
        </ol>
        <div className="p-x2-top" />
        <EsRequirements />
    </div>

</CF>;


const TermsITFR = ()=><CF className="desktop-white max-width-sm ">
    <div className={"sm-p-x2-top sm-p-x2-bottom sm-p-left sm-p-right t-justify"}>
        <div dangerouslySetInnerHTML={{__html: t('signature_page_terms')}}/>
        <div className="p-x2-top" />
        <TechnicalRequirements />
    </div>
</CF>;


let Signature = class extends Component {

    canvasRef = createRef();
    state = {
        uploading: false,
        sign: null,
        useOfImages: null
    }

    async upload(img, docId){
        await this.props.uploadDocument(this.props.auth.loggedUser.id, img, docId);
    }

    clear(){
        this.canvasRef.current.clear()
        this.setState({sign: null})
    }

    async save(){
        await this.setState({uploading:true});
        await this.props.uploadSignature(
            this.props.auth.loggedUser.id,
            this.canvasRef.current.canvas.drawing.toDataURL(),
            this.state.useOfImages
        );
        await this.setState({uploading:false});

    }

    handleSign = (e) => this.setState({sign: e.canvas.drawing.toDataURL()})

    render({status}) {

        //const isSpanish = status.student_meta.shop_id == PS_SHOPID_ES;
        const isSpanish = isSpanishUser(status.student_meta.shop_id)

        return <Fragment>
            {isSpanish ? <TermsES /> : <TermsITFR />}

            <div style="padding-top:32px" />
            <div className="max-width margin-auto" style={{paddingLeft: '4px'}}>
                <CF className="sm-card max-width-sm">
                    <div className='sm-p-x2-top sm-p-x2-bottom sm-p-left sm-p-right t-justify'>
                        <h2 className='m-bottom'>{t('Cesión de los derechos de imágen')}</h2>
                        <div className='m-bottom' dangerouslySetInnerHTML={{__html: t('signature_page_accept_images')}}></div>
                        <C className='m-bottom flexrow'>
                            <E className='sm-col-20 col-50'>
                                <RadioCheckbox
                                  label={t('Aceptar')}
                                  type='radio'
                                  onChange={() => this.setState({ useOfImages: true })}
                                  defaultValue={this.state.useOfImages}
                                />
                            </E>
                            <E className='sm-col-20 col-50'>
                                <RadioCheckbox
                                  label={t('Rechazar')}
                                  type='radio'
                                  onChange={() => this.setState({ useOfImages: false })}
                                  defaultValue={this.state.useOfImages === false}
                                />
                            </E>
                        </C>
                        <div>{t('signature_page_accept_images_2')}</div>
                    </div>
                </CF>
                <div style="padding-top:32px" />

                <h1 className='no-margin m-bottom'>{t('Deja tu firma aquí')}</h1>
            </div>

            <CF className={"desktop-white max-width-sm dashed"+(this.state.uploading?' disabled-link':'')}>
                <CanvasDraw brushRadius={5} brushColor="#000" canvasWidth="100%" ref={this.canvasRef} hideGrid={true} onChange={this.handleSign}/>
            </CF>


            <FR className="max-width-sm margin-auto t-right m-top flex-center-y ">
                <button type="button" className="btn btn-primary  sm-col-25 col-50" onClick={()=>this.save()} disabled={(this.state.uploading || !this.state.sign) || (this.state.useOfImages === null)}>{t('Aceptar')}</button>
                <button type="button" className="btn btn-ghost sm-col-25 col-50" onClick={()=>this.clear()} disabled={this.state.uploading}>{t('Borrar')}</button>
                <div className="col-25flex-center-x t-underline text-primary t-upper cursor-pointer m-l d-none sm-d-block" onClick={()=>history.back()}>{t('Cancelar')}</div>
            </FR>

        </Fragment>;
    }
};

Signature = connect(({auth, status}) => ({auth,status}),
    {
        uploadSignature,
    })(Signature);


const SignaturePage = ({history}) =>
    <AppPage
        name="signature"
        className="max-width-sm"
    >
        <Signature/>
    </AppPage>
;

export default SignaturePage;
